import React from "react";
import { TextButton, ModalButtonsContainer } from "@SeemplicityDev/shared";
import type { Placement } from "@floating-ui/react";

interface ModalActionButtonsProps {
  disableSave?: boolean;
  disableSaveAs?: boolean;
  cancelEdit?: boolean;
  isValid?: boolean;
  validateOnSave?: () => void;
  openSaveAsModal?: () => void;
  hideSaveAs?: boolean;
  onCancelHandler?: () => void;
  saveTooltipContent?: string;
}

const ModalActionButtons: React.FC<ModalActionButtonsProps> = ({
  disableSave,
  disableSaveAs,
  cancelEdit,
  isValid,
  validateOnSave,
  openSaveAsModal,
  hideSaveAs,
  onCancelHandler,
  saveTooltipContent,
}) => {
  const saveTooltip: { place?: Placement; content?: string } | undefined =
    saveTooltipContent
      ? { content: saveTooltipContent, place: "bottom" }
      : undefined;

  return (
    <ModalButtonsContainer>
      {cancelEdit && (
        <TextButton
          type={"button"}
          data-testid={`filter-cancel-edit`}
          label={"Cancel"}
          onClick={onCancelHandler}
        />
      )}

      {cancelEdit && (
        <>
          {!hideSaveAs && (
            <TextButton
              wrapperClassName={"filter-save-as-button"}
              data-testid={`filter-save-as-modal`}
              type={"button"}
              label={"Save As"}
              disabled={!isValid || !!disableSaveAs}
              onClick={openSaveAsModal}
              withTooltip={saveTooltip}
            />
          )}
          <TextButton
            data-testid={`filter-save`}
            type={"button"}
            label={"Save Filter"}
            onClick={validateOnSave}
            disabled={disableSave}
            buttonStyle={"primary"}
            withTooltip={saveTooltip}
          />
        </>
      )}
    </ModalButtonsContainer>
  );
};

export default ModalActionButtons;
